/**
 * Einstiegspunkt des DUELINE-Webclients.
 * Haengt die React-Oberflaeche in die Seite ein.
 *
 * Hinweis zu React.StrictMode:
 * StrictMode startet jeden Effekt in der Entwicklung absichtlich doppelt.
 * Fuer normale Oberflaechen ist das hilfreich, fuer uns nicht: Es wuerde
 * zwei 3D-Kontexte und ZWEI Serververbindungen aus einem einzigen Browserfenster
 * erzeugen - das Match waere damit sofort voll, obwohl nur ein Mensch spielt.
 * Deshalb laeuft der Client bewusst ohne StrictMode.
 */

import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './styles/app.css';
// Das Hauptmenue hat eine eigene Datei: app.css gehoert der Grafiksitzung.
import './styles/menu.css';
// Aus demselben Grund eigenstaendig: der Hinweis zum Home-Bildschirm (15.10.2026).
import './styles/startbildschirm.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Element mit der ID "root" wurde nicht gefunden.');
}

createRoot(container).render(<App />);
